import web3 from 'web3'

export function secondsToDhms(seconds) {
    seconds = Number(seconds);

    if (seconds === 0) return '0 days 0 hours 0 minutes 0 seconds'

    const d = Math.floor(seconds / (3600*24));
    const h = Math.floor(seconds % (3600*24) / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 60);

    const dDisplay = d > 0 ? d + (d === 1 ? " day " : " days ") : "";
    const hDisplay = h > 0 ? h + (h === 1 ? " hour " : " hours ") : "";
    const mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes ") : "";
    const sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : seconds > 0 ? s + (s === 1 ? " second" : " seconds") : "";

    return dDisplay + hDisplay + mDisplay + sDisplay;
}

export function humanCnr(amount)  {
    return (Number(web3.utils.fromWei(amount,'gwei'))*10).toFixed(2)
}

export function uint256Cnr(web3, amount) {
    return web3.eth.abi.encodeParameter('uint256', web3.utils.toWei(amount))
}

export function humanLongTime(timestamp) {
    return new Intl.DateTimeFormat('ru-Ru', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).format(timestamp * 1000)
}

export function humanShortTime(timestamp) {
    return new Intl.DateTimeFormat('ru-Ru', {
        day: '2-digit',
        month: '2-digit',
        hour12: false,
    }).format(timestamp * 1000)
}

export function shortAddress(address = '0x......................', len = 5) {
    return address?.substr(0, 2+len) + '...' + address?.substr(-len)
}
